import CreditReportsComponent from "../../components/loanReports";
import Layout from "../../layout/main";
import StackKit from "@/shared/components/kit/stack";
const CreditReportsPage = () => {
  return (
    <Layout>
      <StackKit direction="column" sx={{ width: "100%", maxWidth: "1740px", gap: 10 }}>
        <CreditReportsComponent />
      </StackKit>
    </Layout>
  );
};


export default CreditReportsPage;
